export var UniversParameterCreate;
(function (UniversParameterCreate) {
    let type;
    (function (type) {
        type["DEFAULT"] = "default";
        type["NETWORK"] = "network";
        type["POSITION"] = "position";
        type["FOOTFALL"] = "footfall";
    })(type = UniversParameterCreate.type || (UniversParameterCreate.type = {}));
})(UniversParameterCreate || (UniversParameterCreate = {}));
